import type { NavigationGuardWithThis, RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import type { User } from '../types/User';
import { defaultPerPage } from '../constants/Pagination';
import { useUserStore } from '../stores/user';

const modAccess = ['Moderator', 'Admin'];

function getRoleDefaultPage(access_level: User['access_level']): RouteLocationRaw {
  return {
    name: access_level !== 'User' ? 'adminOrders' : 'orders',
    query: {
      page: '1',
      per_page: defaultPerPage.toString(),
    },
  };
}

function attachMissingQueries(to: RouteLocationNormalized) {
  if (to.meta.defQuery) {
    let modified = false;
    if (to.meta.defQuery.pagination && (!to.query.page || !to.query.per_page)) {
      to.query.page = '1';
      to.query.per_page = defaultPerPage.toString();
      modified = true;
    }
    if (to.meta.defQuery.sortingCreated && !to.query.sort) {
      to.query.sort = 'created_at:desc';
      modified = true;
    }
    if (modified) {
      return to;
    }
  }
}

export const routeAuthGuard: NavigationGuardWithThis<any> = async (to) => {
  const user = useUserStore();
  await user.loadUserProfile();

  // Private routes guard
  if (!user.isAuthenticated && to.meta.access !== undefined) {
    return { name: 'login' };
  }
  //  Redirect if already logged
  if (to.name === 'home' || (user.isAuthenticated && to.meta.access === undefined)) {
    return getRoleDefaultPage(user.profile.access_level);
  }
  // Authenticate accessing pages
  if (
  // User only
    (to.meta.access === 'User' && user.profile.access_level !== 'User')
    // Moderator and Admin
    || (to.meta.access === 'Moderator' && !modAccess.includes(user.profile.access_level))
    // Admin only
    || (to.meta.access === 'Admin' && user.profile.access_level !== 'Admin')
  ) {
    return getRoleDefaultPage(user.profile.access_level);
  }

  return attachMissingQueries(to);
};
